<template>
    <div>
        <h1 align="center">
            <strong><u> PRIVACY POLICY </u></strong>
        </h1>
        <p>
            This notice describes the privacy policy (    <strong>“Privacy Policy” </strong>or<strong> “Policy”</strong>) of
            TravelQuest.xyz, which is operated by <strong>TravelQuest</strong>, having
            its postal address at <strong>Sderot Tsahal 4, Lod, Israel </strong>
            (hereinafter referred to the <strong>“Company”</strong> or<strong>“TravelQuest”</strong> or <strong>“us”</strong> or    <strong>“our”</strong> or <strong>“we” </strong>or<strong> “Site” </strong>
            or <strong>“Website”</strong>). In this Policy, you shall be referred as    <strong>“you”</strong> or <strong>“your”</strong>, <strong>“user”</strong>
            or <strong>“users”</strong>.
        </p>
        <p>
            This Privacy Policy explains what information of yours will be collected by
            us when you access the Website or when you make purchases on the Website,
            how the information will be used, and how you can control the collection,
            correction, and/or deletion of the information. We will not knowingly use
            or share your information with anyone, except as described in this Privacy
            Policy. The use of information collected through our Site shall be limited
            to the purposes described under this Privacy Policy and our Terms of Use.
        </p>
        <p>
            By visiting our Site or providing your personal information to us or
            placing your order with us, you are accepting and consenting to the
            practices described in this policy. Please note that this includes
            consenting to the processing of any personal information that you provide,
            as described below.
        </p>
        <p>
            IF YOU DO NOT AGREE WITH THESE PRACTICES, PLEASE DO NOT USE THE SERVICES OR
            THE WEBSITE OR PROVIDE US WITH ANY OF YOUR PERSONAL INFORMATION.
        </p>
        <div align="center">
            <table border="1" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                    <td width="460" colspan="2" valign="top">
                        <p align="center">
                            <strong>TABLE OF CONTENT</strong>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="67" valign="top">
                        <p>
                            <strong>Sr. No.</strong>
                        </p>
                    </td>
                    <td width="392" valign="top">
                        <p>
                            <strong>Particular</strong>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="67" valign="top">
                        <p align="right">
                            1.
                        </p>
                    </td>
                    <td width="392" valign="top">
                        <p>
                            What information about the users do we collect?
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="67" valign="top">
                        <p align="right">
                            2.
                        </p>
                    </td>
                    <td width="392" valign="top">
                        <p>
                            Lawful basis for processing personal information
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="67" valign="top">
                        <p align="right">
                            3.
                        </p>
                    </td>
                    <td width="392" valign="top">
                        <p>
                            How do we use this information?
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="67" valign="top">
                        <p align="right">
                            4.
                        </p>
                    </td>
                    <td width="392" valign="top">
                        <p>
                            Deleting your information
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="67" valign="top">
                        <p align="right">
                            5.
                        </p>
                    </td>
                    <td width="392" valign="top">
                        <p>
                            Cookies and Similar Technologies
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="67" valign="top">
                        <p align="right">
                            6.
                        </p>
                    </td>
                    <td width="392" valign="top">
                        <p>
                            Sharing of information
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="67" valign="top">
                        <p align="right">
                            7.
                        </p>
                    </td>
                    <td width="392" valign="top">
                        <p>
                            1. Storage and Security of Information
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="67" valign="top">
                        <p align="right">
                            8.
                        </p>
                    </td>
                    <td width="392" valign="top">
                        <p>
                            Links to third party sites
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="67" valign="top">
                        <p align="right">
                            9.
                        </p>
                    </td>
                    <td width="392" valign="top">
                        <p>
                            1. Rights of EU, EEA and UK users/service providers
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="67" valign="top">
                        <p align="right">
                            10.
                        </p>
                    </td>
                    <td width="392" valign="top">
                        <p>
                            California Resident Rights
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="67" valign="top">
                        <p align="right">
                            11.
                        </p>
                    </td>
                    <td width="392" valign="top">
                        <p>
                            How do we respond to legal requests?
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="67" valign="top">
                        <p align="right">
                            12.
                        </p>
                    </td>
                    <td width="392" valign="top">
                        <p>
                            Children Privacy
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="67" valign="top">
                        <p align="right">
                            13.
                        </p>
                    </td>
                    <td width="392" valign="top">
                        <p>
                            How do I withdraw my consent?
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="67" valign="top">
                        <p align="right">
                            14.
                        </p>
                    </td>
                    <td width="392" valign="top">
                        <p>
                            Governing law and Dispute Resolution
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="67" valign="top">
                        <p align="right">
                            15.
                        </p>
                    </td>
                    <td width="392" valign="top">
                        <p>
                            Do you have any questions or concerns about this
                            privacy policy?
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="67" valign="top">
                        <p align="right">
                            16.
                        </p>
                    </td>
                    <td width="392" valign="top">
                        <p>
                            Welcoming of suggestions
                        </p>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <p>
            <strong>1. </strong>
            <strong>What information about the users do we collect?</strong>
        </p>
        <p>
            a) <strong>Information that you provide us</strong>: We collect the
            information you provide when you use our services, including without
            limitation, when you register for an account, browse our website/app,
            create a game, purchase tickets, participate in a game, make the payment,
            engage with us through any social media platform, signup for newsletter,
            share your feedback, submit a complaint, communicate or interact with us in
            any manner. This can include Personally Identifiable Information (PII) as
            well as non-PII information.
            <u>
                The examples include your full name, address, email address, contact
                number, photos, videos, content, location, your queries etc.
            </u>
            We also collect information about how you use our services, such as the
            content you engage with or the frequency and duration of your activities.
        </p>
        <p>
            b) <strong>Information that we collect when you use the Website</strong>:
            We also collect information while you access, browse, view or otherwise use
            the Website. In other words, when you access the Website, we are aware of
            your usage of the Website, and gather, collect and record the information
            relating to such usage, including geo-location information, IP address,
            device and connection information, browser information and web-log
            information.
        </p>
        <p>
            c) <strong>Devise Information</strong>: In addition to log data, we may
            also collect information about the device users are using TravelQuest on,
            including what type of device it is, what operating system they’re using,
            and crash data. Whether we collect some or all of this information often
            depends on what type of device the user is using and its settings.
        </p>
        <p>
            d) <strong>Geo Location</strong>: Precise GPS from mobile devices is
            collected only with a user’s permission. IP addresses received from a
            user’s browser or device may be used to determine approximate location.
        </p>
        <p>
            e) <strong>Information that we collect from third party sources</strong>:
            You can engage with us through social media websites or mobile
            applications. When you engage with us through social media sites, such as
            Instagram, you allow us to have access to certain information from your
            social media profile based upon your privacy preference settings on such
            platform.
        </p>
        <p>
            f) We will also collect your payment method, so as to provide you a quicker
            access. Credit card information is securely transmitted over banking grade
            SSL certificates to our payment processor, namely, iCredit. We do not store
            the full credit card details in our database
        </p>
        <p>
            g) We suggest that you exercise good judgment and caution while providing
            your personal information.
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>2. </strong>
            <strong>
                What is the GDPR Privacy lawful basis for which we use your personal
                information?
            </strong>
        </p>
        <p>
            For the purposes of the    <strong>GDPR (General Data Protection Regulation)</strong>, you hereby
            acknowledge that all processing of your personal information will be
            justified by a <strong><em>"lawful ground"</em></strong> for processing. In
            the majority of cases, processing will be justified on the basis that:
        </p>
        <ul>
            <li>
                <strong>Consent: </strong>
                You have given your consent for processing personal data for one or
                more specific purposes.
            </li>
            <li>
                <strong>Performance of a contract: </strong>
                Provision of personal data is necessary for the performance of an
                agreement with you and/or for any pre-contractual obligations thereof.        <strong></strong>
            </li>
            <li>
                <strong>Legal obligations: </strong>
                Processing personal data is necessary for compliance with a legal
                obligation to which we are subject.<strong></strong>
            </li>
            <li>
                <strong>Vital interests: </strong>
                Processing personal data is necessary in order to protect your vital
                interests or of another natural person.<strong></strong>
            </li>
            <li>
                <strong>Public interests: </strong>
                Processing personal data is related to a task that is carried out in
                the public interest or in the exercise of official authority vested in
                the Company.<strong></strong>
            </li>
            <li>
                <strong>Legitimate interests: </strong>
                Processing personal data is necessary for the purposes of the
                legitimate interests pursued by the Company.<strong></strong>
            </li>
        </ul>
        <p>
            <strong></strong>
        </p>
        <p>
            In any case, we will gladly help to clarify the specific legal basis that
            applies to the processing, and in particular whether the provision of
            personal data is a statutory or contractual requirement, or a requirement
            necessary to enter into a contract.    <u>Feel free to contact us for this purpose</u>.
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>3. </strong>
            <strong>How do we use the information collected from you?</strong>
        </p>
        <p>
            We use all of the information we have to help us provide, support and
            improve our services and to facilitate the purpose for which you provide
            the information. We use the information collected from you for the
            following purposes:-
        </p>
        <p>
            a) To create and update your account;
        </p>
        <p>
            b) To provide you the ticket to the game(s);
        </p>
        <p>
            c) To process your cancellation and refund requests;
        </p>
        <p>
            d) To enable you to create games (If you are Creator), and to enable you to
            participate in the games (if you are a user);
        </p>
        <p>
            e) To assess queries, requirements, and process requests for services;
        </p>
        <p>
            f) To enhance your virtual gaming and social experience, including as a way
            to recognize you and welcome you to the Site/App.
        </p>
        <p>
            g) To improve our site, products/services and customer service.
        </p>
        <p>
            h) To be able to deliver our services, personalize content, and make
            suggestions for you by using this information to understand how you use and
            interact with our services and the people or things you’re connected to and
            interested in on and off our services.
        </p>
        <p>
            i) We use your information to send you marketing communications,
            newsletter, communicate with you about our services and let you know about
            our policies and terms. We also use your information to respond to you when
            you contact us.
        </p>
        <p>
            j) We use the information we have to improve our advertising and
            measurement systems so we can show you relevant ads on our services and
            measure the effectiveness and reach of ads and services.
        </p>
        <p>
            k) We use the information we have to help verify accounts and activity, and
            to promote safety and security on of our services, such as by investigating
            suspicious activity or violations of our terms or policies.
        </p>
        <p>
            l) We also use your information to ensure our services are working as
            intended, such as tracking outages or troubleshooting issues that you
            report to us. And we use your information to make improvements to our
            services.
        </p>
        <p>
            m) We use information to help improve the safety and reliability of our
            services. This includes detecting, preventing, and responding to fraud,
            abuse, security risks, and technical issues that could harm Company, our
            users, or the public.
        </p>
        <p>
            n) To respond to summons, court orders, directions or other judicial
            processes.
        </p>
        <p>
            o) To provide information to law enforcement agencies or in connection with
            an investigation on matters related to public safety.
        </p>
        <p>
            <strong>4. </strong>
            <strong>Deleting your information</strong>
        </p>
        <p>
            Your information, account and the feedback that you share on our platform
            is yours. You can at any time delete the same, except the one as shared by
            or visible to other users or creators. However, you acknowledge that we may
            retain some of the information so deleted for a reasonable period of time
            in order to comply with legal requests. You can request us to delete your
            information by writing to us at <strong>dan@travelAndQuest.com</strong>
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>5. </strong>
            <strong>Cookies and Similar Technologies</strong>
        </p>
        <p>
            Cookies are bits of electronic information that a website may transfer to a
            visitor’s computer to identify specific information about the visitor’s
            visits to other website. We may use automated technologies including the
            use of web server logs to collect IP addresses, device details, cookies and
            web beacons. The Website uses a browser feature known as a cookie, which
            assigns a unique identification to your computer. However, in case you do
            not wish for us to collect such information, simply change the cookie
            settings on your web browser. For more information, please refer to our    <strong>Cookie Policy</strong> available on our website.
        </p>
        <p>
            <strong>6. </strong>
            <strong>Sharing of Information</strong>
        </p>
        <p>
            a) Whenever you post or share the feedback on the Site, such feedback,
            including your name is publicly viewable by the users and viewers of Site.
        </p>
        <p>
            b) The content, such as photos, videos, sound material, etc. that you share
            during your participation in a particular game, either on or off our
            platform, will be stored and dealt with in accordance to the privacy policy
            or terms of such creator.
        </p>
        <p>
            c) We share your personal information with our third-party creators and
            hosting service providers, namely Google Could and Firebase, who’s ticket
            you purchase.
        </p>
        <p>
            d) We keep your information safe and do not share your information with any
            other third party. However, if we merge with or are acquired by another
            pro or we sell our Website or business unit, or if all or a substantial
            portion of our assets are acquired by another pro, in those cases, your
            information will likely be one of the assets that would be transferred.
        </p>
        <p>
            e) We may also share your information in response to legal request. Please
            refer to <strong>Section 11</strong>.
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>7. </strong>
            <strong>Storage and Security of Information</strong>
        </p>
        <p>
            a) <strong>Storage: </strong>Your data is stored on Google Cloud and
            Firebase, which are our third party hosting service providers. The servers
            of the above-mentioned hosting service providers are located in United
            States of America (USA) (in multiple regions) and europe-west1 (Belgium).
            We also store the information collected by us on our servers and do not
            share it with any third party, except for the limited purposes as mentioned
            in the <strong>Section 6</strong>. The servers and databases in which
            information may be stored may be located outside the country from which you
            accessed this website and in a country/State where the data protection and
            other laws may differ <strong><em>(and be less stringent)</em></strong>
            from your country of residence.
            <strong>
                <u>
                    You hereby consent to any such cross-border transfer of your
                    personal information.
                </u>
            </strong>
        </p>
        <p>
            b) <strong>Retention: </strong>Personal information that we collect, access
            or process will be retained only so long as necessary for the fulfillment
            of the purposes for which it was collected, as necessary for our legitimate
            business purposes, or as required or authorized by law. Personal
            information that is no longer required to fulfil the identified purposes
            will be destroyed, erased or made de-identified or anonymous.    <strong></strong>
        </p>
        <p>
            c) <strong>Security: </strong>We as well as our third party hosting service
            providers adopt reasonable security practices to ensure that the
            information is safe and secure with us. However, no information on the
            internet is 100% safe, and you accept and acknowledge such risk. Also, we
            will disclose the information so collected for limited purposes as
            mentioned in this Privacy Policy.<strong></strong>
        </p>
        <p>
            <strong>8. </strong>
            <strong>Links to other sites</strong>
        </p>
        <p>
            The Website may contain links to third-party websites, service providers
            and virtual services that are not owned or controlled by us, such as
            third-party payment gateway service provider. We have no control over, and
            assume no responsibility for such websites and virtual services. Be aware
            when you leave the Website; we suggest you read the terms and privacy
            policy of each third-party websites, service provider and virtual service
            that you visit.
        </p>
        <p>
            <strong>9. </strong>
            <strong>Rights of EU, EEA and UK users</strong>
        </p>
        <p>
            This section of the Policy supplements the other provisions of this Privacy
            Policy, and applies to you if you are in the EU, the European Economic Area
            (EEA) or UK.
        </p>
        <p>
            <strong>
                ALL YOUR USER INFORMATION WILL BE COLLECTED, STORED, PROCESSED AND
                SHARED STRICTLY IN ACCORDANCE, IN LINE AND FULL COMPLIANCE WITH
                REGULATION (EU) 2016/679 (SIMPLY CALLED “GDPR”) AND DIRECTIVE
                2002/58/EC (SIMPLY CALLED “E-PRIVACY DIRECTIVE, 2002”) OF THE EUROPEAN
                PARLIAMENT AND OF THE COUNCIL (HERINAFTER COLLECTIVELY REFERRED TO AS
                THE “EU REGULATION”). AS BETWEEN US AND THE CREATORS, CREATORS ARE THE
                DATA CONTROLLERS OF THE DATA THAT WE COLLECT FROM YOU ON THEIR BEHALF,
                AND FOR ALL THE DATA THAT THEY COLLECT FROM YOU DIRECTLY.
            </strong>
        </p>
        <p>
            Under applicable EU regulation, you have the following rights in respect of
            your personal information:
        </p>
        <ul>
            <li>
                <strong>Right to obtain information</strong>
                : to obtain information about how and on what basis your personal
                information is processed and to obtain a copy;
            </li>
            <li>
                <strong>Right to rectification:</strong>
                You have the right to have any incomplete or inaccurate information we
                hold about you rectified and corrected.
            </li>
            <li>
                <strong>Right of Erasure:</strong>
                to erase your personal information in limited circumstances where (a)
                you believe that it is no longer necessary for us to hold your personal
                information; (b) we are processing your personal information on the
                basis of legitimate interests and you object to such processing, and we
                cannot demonstrate an overriding legitimate ground for the processing;
                (c) where you have provided your personal information to us with your
                consent and you wish to withdraw your consent and there is no other
                ground under which we can process your personal information; and (d)
                where you believe the personal information we hold about you is being
                unlawfully processed by us;
            </li>
            <li>
                <strong>Right of restriction:</strong>
                to restrict processing of your personal information where: (a) the
                accuracy of the personal information is contested; (b) the processing
                is unlawful but you object to the erasure of the personal information;
                (c) we no longer require the personal information for the purposes for
                which it was collected, but it is required for the establishment,
                exercise or defence of a legal claim or (d) you have objected to us
                processing your personal information based on our legitimate interests
                and we are considering your objection;
            </li>
            <li>
                <strong>Right to object:</strong>
                to object to decisions which are based solely on automated processing
                or profiling;
            </li>
            <li>
                <strong>Right to ask for a copy:</strong>
                where you have provided your personal information to us with your
                consent, to ask us for a copy of this data in a structured,
                machine-readable format and to ask us to share (port) this data to
                another data controller; or to obtain a copy of or access to safeguards
                under which your personal information is transferred outside of the
                EEA.
            </li>
            <li>
                <strong>Right to withdraw your consent.</strong>
                You have the right to withdraw your consent on using your personal
                data. If you withdraw your consent, we may not be able to provide you
                with access to certain specific functionalities of our services.
            </li>
            <li>
                <strong>Request the transfer of your Personal Data.</strong>
                We will provide to you, or to a third-party you have chosen, your
                personal data in a structured, commonly used, machine-readable format.
                Please note that this right only applies to automated information which
                you initially provided consent for us to use or where we used the
                information to perform a contract with you.
            </li>
        </ul>
        <p>
            <strong>
                Under certain circumstances, you may have the right to object, on
                grounds relating to your particular situation, to the processing of
                your personal data by us and we may be required to no longer process
                your personal data. Moreover, if your personal data is processed for
                direct marketing purposes, you have the right to object at any time to
                the processing of personal data concerning you for such marketing,
                which includes profiling to the extent that it is related to such
                direct marketing. In this case your personal data will no longer be
                processed for such purposes by us.
            </strong>
        </p>
        <p>
            In addition to the above, you have the right to lodge a complaint with a
            supervisory authority for data protection. Please note that the right of
            access and the right to erasure do not constitute absolute rights and the
            interests of other individuals may restrict your right of access or erase
            in accordance with local laws.
        </p>
        <p>
            We will ask you for additional data to confirm your identity and for
            security purposes, before disclosing data requested by you. We reserve the
            right to charge a fee where permitted by law. We will decline to process
            requests that jeopardize the privacy of others, are extremely impractical,
            or would cause us to take any action that is not permissible under
            applicable laws. Additionally, as permitted by applicable laws, we will
            retain where necessary certain personal information for a limited period of
            time for record-keeping, accounting and fraud prevention purposes.
        </p>
        <p>
            <strong>
                To make such requests, please contact us at dan@travelAndQuest.com
            </strong>
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>10. </strong>
            <strong>California Resident Rights</strong>
        </p>
        <p>
            This section of the Policy applies to you, if you are a California
            resident, as per <strong>California Consumer Policy Act, 2018</strong>
            (simply called <strong>“CCPA”</strong>) and<strong>California Online Privacy Protection Act</strong> (simply called    <strong>“COPPA”</strong>). This privacy notice section for California
            residents supplements the information contained in our Privacy Policy and
            it applies solely to all visitors, users, and others who reside in the
            State of California.
        </p>
        <p>
            <strong>Categories of Personal Information Collected</strong>
        </p>
        <p>
            We collect information that identifies, relates to, describes, references,
            is capable of being associated with, or could reasonably be linked,
            directly or indirectly, with a particular consumer or device. The following
            is a list of categories of personal information which we may collect or may
            have been collected from California residents within the last twelve (12)
            months.
        </p>
        <p>
            Please note that the categories and examples provided in the list below are
            those defined in the CCPA. This does not mean that all examples of that
            category of personal information were in fact collected by us, but reflects
            our good faith belief to the best of our knowledge that some of that
            information from the applicable category may be and may have been
            collected. For example, certain categories of personal information would
            only be collected if you provided such personal information directly to us.
        </p>
        <ul type="disc">
            <li>
                <strong>Category A: Identifiers.</strong>
            </li>
        </ul>
        <p>
            <strong>Examples: </strong>
            A real name, alias, postal address, unique personal identifier, virtual
            identifier, Internet Protocol address, email address, account name,
            driver's license number, passport number, or other similar identifiers.
        </p>
        <p>
            <strong>Collected:</strong>
            Yes.
        </p>
        <ul type="disc">
            <li>
                <strong>
                    Category B: Personal information categories listed in the
                    California Customer Records statute (Cal. Civ. Code § 1798.80(e)).
                </strong>
            </li>
        </ul>
        <p>
            <strong>Examples:</strong>
            A name, signature, Social Security number, physical characteristics or
            description, address, telephone number, passport number, driver's license
            or state identification card number, insurance policy number, education,
            employment, employment history, bank account number, credit card number,
            debit card number, or any other financial information, medical information,
            or health insurance information. Some personal information included in this
            category may overlap with other categories.
        </p>
        <p>
            <strong>Collected:</strong>
            Yes.
        </p>
        <ul type="disc">
            <li>
                <strong>
                    Category C: Protected classification characteristics under
                    California or federal law.
                </strong>
            </li>
        </ul>
        <p>
            <strong>Examples:</strong>
            Age (40 years or older), race, color, ancestry, national origin,
            citizenship, religion or creed, marital status, medical condition, physical
            or mental disability, sex (including gender, gender identity, gender
            expression, pregnancy or childbirth and related medical conditions), sexual
            orientation, veteran or military status, genetic information (including
            familial genetic information).
        </p>
        <p>
            <strong>Collected:</strong>
            No.
        </p>
        <ul type="disc">
            <li>
                <strong>Category D: Commercial information.</strong>
            </li>
        </ul>
        <p>
            <strong>Examples:</strong>
            Records and history of products or services purchased or considered.
        </p>
        <p>
            <strong>Collected:</strong>
            Yes.
        </p>
        <ul type="disc">
            <li>
                <strong>Category E: Biometric information.</strong>
            </li>
        </ul>
        <p>
            <strong>Examples:</strong>
            Genetic, physiological, behavioral, and biological characteristics, or
            activity patterns used to extract a template or other identifier or
            identifying information, such as, fingerprints, faceprints, and
            voiceprints, iris or retina scans, keystroke, gait, or other physical
            patterns, and sleep, health, or exercise data.
        </p>
        <p>
            <strong>Collected:</strong>
            No.
        </p>
        <ul type="disc">
            <li>
                <strong>
                    Category F: Internet or other similar network activity.
                </strong>
            </li>
        </ul>
        <p>
            <strong>Examples:</strong>
            Interaction with our Service or advertisement.
        </p>
        <p>
            <strong>Collected:</strong>
            Yes.
        </p>
        <ul type="disc">
            <li>
                <strong>Category G: Geolocation data.</strong>
            </li>
        </ul>
        <p>
            <strong>Examples:</strong>
            Approximate physical location.
        </p>
        <p>
            <strong>Collected:</strong>
            Yes.
        </p>
        <ul type="disc">
            <li>
                <strong>Category H: Sensory data.</strong>
            </li>
        </ul>
        <p>
            <strong>Examples:</strong>
            Audio, electronic, visual, thermal, olfactory, or similar information.
        </p>
        <p>
            <strong>Collected: </strong>
            No.
        </p>
        <ul type="disc">
            <li>
                <strong>
                    Category I: Professional or employment-related information.
                </strong>
            </li>
        </ul>
        <p>
            <strong>Examples:</strong>
            Current or past job history or performance evaluations.
        </p>
        <p>
            <strong>Collected:</strong>
            No.
        </p>
        <ul type="disc">
            <li>
                <strong>
                    Category J: Non-public education information (per the Family
                    Educational Rights and Privacy Act (20 U.S.C. Section 1232g, 34
                    C.F.R. Part 99)).
                </strong>
            </li>
        </ul>
        <p>
            <strong>Examples:</strong>
            Education records directly related to a student maintained by an
            educational institution or party acting on its behalf, such as grades,
            transcripts, class lists, student schedules, student identification codes,
            student financial information, or student disciplinary records.
        </p>
        <p>
            <strong>Collected:</strong>
            No.
        </p>
        <ul type="disc">
            <li>
                <strong>
                    Category K: Inferences drawn from other personal information.
                </strong>
            </li>
        </ul>
        <p>
            <strong>Examples:</strong>
            Profile reflecting a person's preferences, characteristics, psychological
            trends, predispositions, behavior, attitudes, intelligence, abilities, and
            aptitudes.
        </p>
        <p>
            <strong>Collected:</strong>
            Yes (depends on game that user participates in).
        </p>
        <p>
            <strong>Under CCPA, personal information does not include:</strong>
        </p>
        <ul type="disc">
            <li>
                Publicly available information from government records
            </li>
            <li>
                Deidentified or aggregated consumer information
            </li>
            <li>
                Information excluded from the CCPA's scope, such as:
            </li>
            <ul type="circle">
                <li>
                    Health or medical information covered by the
                    <strong>
                        Health Insurance Portability and Accountability Act of 1996
                        (HIPAA)
                    </strong>
                    and the
                    <strong>
                        California Confidentiality of Medical Information Act (CMIA)
                    </strong>
                    or clinical trial data
                </li>
                <li>
                    Personal Information covered by certain sector-specific privacy
                    laws, including the Fair Credit Reporting Act (FRCA), the
                    Gramm-Leach-Bliley Act (GLBA) or California Financial Information
                    Privacy Act (FIPA), and the Driver's Privacy Protection Act of 1994
                </li>
            </ul>
        </ul>
        <p>
            We use the personal information that we collect or receive for the business
            purposes as described above. We may disclose the above listed categories of
            personal information to third parties for business purposes as described
            above. As previously mentioned in this Policy, we do not “sell” (as such
            term is defined in the CCPA) personal information.
        </p>
        <p>
            <strong>
                You are entitled to the following specific rights under the CCPA in
                relation to personal information related to you:
            </strong>
        </p>
        <p>
            · You have a right to request that we will disclose certain information to
            you about our collection and use of personal information related to you
            over the past 12 months, including: (i) The categories of personal
            information that we collect about you; (ii)The categories of sources from
            which the personal information is collected; (iii) The purposes for
            collecting, using, or selling that personal information. (iv) The
            categories of personal information that we disclosed for a business purpose
            or sold, and the categories of third parties to whom we disclosed or sold
            that particular category of personal information. (v) The specific pieces
            of personal information that we have collected about you.
        </p>
        <p>
            · You have a right to request that we delete personal information related
            to you that we collected from you under certain circumstances and
            exceptions.
        </p>
        <p>
            · You also have a right not to be discriminated against for exercising your
            rights under the CCPA.
        </p>
        <p>
            · You also have a right to submit your request via an authorized agent. If
            you use an authorized agent to submit a request to access or delete your
            personal information on your behalf, the authorized agent must: (1) be a
            person or business entity registered with the California Secretary of State
            to conduct business in California; (2) provide proof of such registration;
            and (3) provide documentation or other proof indicating that they are
            authorized to act on your behalf. We may also require you to verify your
            identity directly with us, and directly confirm with us that you provided
            the authorized agent permission to submit the request.
        </p>
        <p>
            <strong>
                <u>
                    To make such requests, please contact us at dan@travelAndQuest.com
                </u>
            </strong>
        </p>
        <p>
            We will verify your request using the information associated with your
            account, including email address. Government identification may also be
            required.
        </p>
        <p>
            <em>
                <u>
                    A request for access can be made by you only twice within a
                    12-months period. Any disclosures that we provide will only cover
                    the 12-months period preceding receipt of your request. We do not
                    charge a fee to process or respond to your verifiable User request
                    unless it is excessive, repetitive, or manifestly unfounded. If we
                    determine that the request warrants a fee, we will inform you of
                    the reasons for such decision and provide you with a cost estimate
                    before processing further your request.
                </u>
            </em>
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>11. </strong>
            <strong>How do we respond to legal requests?</strong>
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            We may access, preserve and share your information in response to a legal
            request (like a search warrant, court order or subpoena) if we have a good
            faith belief that the law requires us to do so. This may include responding
            to legal requests from law enforcement agencies, courts, tribunals and
            government authorities. We may also access, preserve and share information
            when we have a good faith belief it is necessary to: detect, prevent and
            address fraud and other illegal activity; to protect ourselves, you and
            others, including as part of investigations; or to prevent death or
            imminent bodily harm. For example, we may provide information to
            third-party partners about the reliability of your account to prevent fraud
            and abuse on and off of our Services. We also may retain information from
            accounts disabled for violations of our terms for at least a year to
            prevent repeat abuse or other violations of our terms.<strong></strong>
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>12. </strong>
            <strong>Children Privacy</strong>
        </p>
        <p>
            Protecting children's privacy is important to us, and therefore our Website
            does not knowingly collect any personal information from such children. If
            you are not of majority <em>(or above) </em>as per the law of jurisdiction
            that applies to you, you are not authorized to use the Services. If the
            Company learns that a child has provided personally identifiable
            information to the Website, it will use reasonable efforts to remove such
            information from its database.
            <strong>
                <u>
                    Please contact us at dan@travelAndQuest.com if you believe we
                    knowingly or unknowingly collected information described in this
                    Section.
                </u>
            </strong>
            <strong></strong>
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>13. </strong>
            <strong>How can I withdraw my consent? (OPT-OUT)</strong>
        </p>
        <p>
            If you make a purchase, you will automatically start receiving promotional
            emails and direct mail from us. If after you opt-in, you change your mind,
            you may withdraw your consent for us to contact you, for the continued
            collection, use or disclosure of your information, at any time, by
            contacting us at:
        </p>
        <ul>
            <li>
                dan@TravelAndQuest.com
            </li>
        </ul>
        <p>
            · Sderot Tsahal 4, Lod, Israel<strong></strong>
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>14. </strong>
            <strong>Governing law and Dispute Resolution</strong>
        </p>
        <p>
            Unless provided by the relevant statute, rules, or directives applicable to
            the jurisdiction in which you reside, in case of any disputes, issues,
            claims or controversies arising out of or in relation to your use of the
            Website, Product or our services, the governing law and dispute resolution
            mechanism as provided in the <strong>Terms of Use</strong> shall apply to
            this <strong>Privacy Policy</strong> as well.
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>15. </strong>
            <strong>
                Do you have questions or concerns about this Privacy Policy?
            </strong>
        </p>
        <p>
            In the event you have any grievance regarding anything related to this
            Privacy Policy, Cookie Policy, Disclaimer, Creator Terms, Terms of Use, or
            with any content or service of ours, in that case you may freely write your
            concerns through your registered email to Grievance Officer/Designated
            Representative to below:
        </p>
        <ul>
            <li>
                <strong>Name: Dan</strong>
            </li>
            <li>
                <strong>Email: Dan@TravelAndQuest.com</strong>
            </li>
            <li>
                <strong>Contact: </strong>
            </li>
        </ul>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>16. </strong>
            <strong>Welcoming of suggestions</strong>
        </p>
        <p>
            We welcome your comments regarding this Privacy Policy. Please write to us
            at <strong>dan@travelAndQuest.com</strong>
        </p>
        <p>
            Last updated on<strong> 29.12.2021</strong>
        </p>

    </div>
</template>

<script>
export default {
    name: "v_Terms_CookiePolicy"
}
</script>

<style scoped>
p{
    margin: 16px;
}
</style>